import React, { memo, useMemo } from "react";
import { BaseEdge, EdgeProps } from "reactflow";
import { getEdgePath } from "./utils";
import useFlowsStore from "../../store/storeFlows";
import EdgeBaseWrapper from "./EdgeBaseWrapper";

const LoopEdge = (props: EdgeProps) => {
  const {
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    id,
    data,
    style,
  } = props;
  const { lineType } = useFlowsStore((state) => state);

  const adjustedTargetY = targetY - 5;
  const isInLoop = data?.isLoop || false;

  const [edgePath2] = getEdgePath(lineType, {
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY: adjustedTargetY + 5,
    targetPosition,
  });

  const edgeStyles = useMemo(() => {
    if (isInLoop) {
      return {
        stroke: "#4ade80",
        strokeWidth: 1,
        strokeDasharray: "none",
        fill: "none",
      };
    }
    return { stroke: "#22c55e", strokeWidth: 1 };
  }, [isInLoop]);

  const gradientId = `loop-gradient-${id}`;

  return (
    <EdgeBaseWrapper
      {...props}
      style={{ ...style, ...edgeStyles }}
      showDeleteButton={false}
      renderLabel={() => (
        <div
          style={{
            position: "absolute",
            left: (sourceX + targetX) / 2,
            top: (sourceY + adjustedTargetY) / 2,
            fontSize: "10px",
            fontWeight: "bold",
            color: "#ffffff",
            backgroundColor: "#4ade80",
            padding: "3px 6px",
            borderRadius: "4px",
            border: "2px solid #22c55e",
            whiteSpace: "nowrap",
            zIndex: 1000,
            transform: "translate(-50%, -50%)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
            pointerEvents: "none",
          }}
        >
          LOOP
        </div>
      )}
    >
      {isInLoop && (
        <>
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#4ade80" />
              <stop offset="50%" stopColor="#22c55e" />
              <stop offset="100%" stopColor="#16a34a" />
            </linearGradient>
          </defs>
          <BaseEdge
            path={edgePath2}
            style={{
              ...style,
              stroke: "#4ade80",
              strokeWidth: 1,
              fill: "none",
              strokeDasharray: "none",
            }}
          />
        </>
      )}
    </EdgeBaseWrapper>
  );
};

export default memo(LoopEdge);
